<div id="chartdiv" style="width: 100%; height: 500px"></div>